import { Flex, Image as ChakraImage, Box } from "@chakra-ui/react";
import Modal from "components/Modal";
import Heading, { HeadingType } from "./Heading";
import { useState } from "react";
import { MessageType } from "core/chat/types";
import Image from "next/image";
import RotateLeftIcon from "lib/svgs/RotateLeftIcon";
import RotateRightIcon from "lib/svgs/RotateRightIcon";

interface OwnProps {
  modalEnabled: boolean;
  handleClose: () => void;
  imageUrl: string;
  imageType?: MessageType.PHOTO | MessageType.PHOTO_B64 | null;
  title: string;
}
export default function EnlargedImageModal(props: OwnProps): JSX.Element {
  const [rotation, setRotation] = useState<number>(0);
  const handleRotateLeft = () => {
    setRotation(rotation - 90);
  };

  const handleRotateRight = () => {
    setRotation(rotation + 90);
  };

  return (
    <Modal transparent onClose={props.handleClose} isOpen={props.modalEnabled}>
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
        minWidth="1000px"
        borderRadius="12px"
        backgroundColor="primary.7"
      >
        <Heading paddingTop="16px" type={HeadingType.HEADING_MED}>
          {props.title}
        </Heading>
        <Box>
          {props.imageType && props.imageType === MessageType.PHOTO_B64 ? (
            <Box
              maxWidth="750px"
              maxHeight="750px"
              transform={`rotate(${rotation}deg)`}
            >
              <Flex
                style={{
                  borderRadius: "4px",
                }}
              >
                <Image
                  src={`data:image/jpg;base64,${String(props.imageUrl)}`}
                  width="600px"
                  height="600px"
                  unoptimized
                />
              </Flex>
            </Box>
          ) : (
            <ChakraImage
              padding="30px"
              maxWidth="750px"
              maxHeight="750px"
              transform={`rotate(${rotation}deg)`}
              src={String(props.imageUrl)}
            />
          )}
        </Box>
        <Flex flexDirection="row" marginTop="12px" marginBottom="24px">
          <Box
            _hover={{ cursor: "pointer" }}
            onClick={handleRotateLeft}
            width="40px"
            height="40px"
            marginRight="12px"
          >
            <RotateLeftIcon />
          </Box>
          <Box
            _hover={{ cursor: "pointer" }}
            onClick={handleRotateRight}
            width="40px"
            height="40px"
          >
            <RotateRightIcon />
          </Box>
        </Flex>
      </Flex>
    </Modal>
  );
}
